import { BaseDataService } from './BaseDataService';
import { Note } from '../../models';
import { NotificationService } from '../../services';
import { OpenBlobFile } from '../../utilities';

export class NoteDataService extends BaseDataService<Note> {
    constructor(notificationService: NotificationService) {
        super('Note', 'Notes', notificationService);
    }

    public getPDF(id: number): Promise<any> {
        var endpoint = `${this.endpointRoot}/PDF/${id}`;
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            // this returns a SurveyAssessmentViewModel
            if (response.ok) {
                return response.blob();
            }
            const message = `Error retrieving survey responses.`;
            this.notificationService.addError(message);
            throw new Error(message);
        }).then((blobData: any) => {
            return OpenBlobFile(blobData, 'Node.pdf');
        });

    }
    public update(entity: Note): Promise<any> {
        entity.content = entity.content.replace(/\n/g, '<br />');
        return super.update(entity);
    }
}


// WEBPACK FOOTER //
// ./src/services/api/NoteDataService.tsx